module.exports = __webpack_public_path__ + "static/media/person.200bc1f2.svg";